import { render } from "./NewCertificateDialogAgrementTab.vue?vue&type=template&id=13e89db2"
import script from "./NewCertificateDialogAgrementTab.vue?vue&type=script&lang=js"
export * from "./NewCertificateDialogAgrementTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__